<script>
import CampaignSelector from '../CampaignSelector.vue';

export default {
  components: { CampaignSelector },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    enabledFeatures: {
      type: Object,
      required: true,
    },
    activeCampaigns: {
      type: Array,
      default: () => [], // Array com as chaves das campanhas que devem estar ativas
    },
  },
  emits: ['campaignItemClick'],
  computed: {
    isActive() {
      const { key } = this.campaign;
      
      // Verifica se a campanha está na lista de campanhas ativas
      return this.activeCampaigns.includes(key);
    },
  },
  methods: {
    getCampaignThumbnail() {
      if (this.campaign.key === 'api' && this.campaign.thumbnail) {
        return this.campaign.thumbnail;
      }
      return `/assets/images/dashboard/channels/${this.campaign.key}.png`;
    },
    onItemClick() {
      if (this.isActive) {
        this.$emit('campaignItemClick', this.campaign.key);
      }
    },
  },
};
</script>

<template>
  <CampaignSelector
    :class="{ inactive: !isActive }"
    :title="campaign.name"
    :src="getCampaignThumbnail()"
    class="border border-slate-100 dark:border-green-800 bg-green-50 dark:bg-green-900/10"
    @click="onItemClick"
  />
</template>